export default __webpack_public_path__ + "static/media/client-25.5fc8f6b9.png";